<template>

  <modalo
    :title="dashcomponent.name"
    :type="{'builder': 'long', 'modules': 'small'}[stage]"
    @hideModal="hideModal()"
    :modaloWatch="() => dashcomponent">

    <creating
      v-if="creating"
      height="100%" />

    <DashcomponentFormModules
      v-if="stage === 'modules'"
      @change="selectModule" />

    <form
      v-if="stage === 'builder'"
      id="dashcomponent-form"
      v-on:submit.prevent="saveDashcomponent(dashcomponent)">

      <div class="form-row">
        <div class="col-md-3">
          <div class="form-group">
            <label>{{ $t('Name') }}</label>
            <input
              v-autofocus
              type="text"
              class="form-control"
              v-model="dashcomponent.name" maxlength="60">
            <ValidateMessage :error="validateErrors.name" />
          </div>
          <div class="form-group">
            <label>{{ $t('Default date') }}</label>
            <Select
              v-model="dashcomponent.date_range"
              :options="builder.dates_range" />
            <ValidateMessage :error="validateErrors.date_range" />
          </div>
          <div class="form-group">
            <label>{{ $t('Type') }}</label>
            <select
              class="form-control"
              v-model="dashcomponent.type">
              <option value="columns">Colunms</option>
              <option value="pizza">Pizza</option>
              <option value="summary">Summary</option>
              <option value="table">Table</option>
            </select>
            <ValidateMessage :error="validateErrors.type" />
          </div>
          <div v-if="['columns'].includes(dashcomponent.type)">
            <div
              class="form-group">
              <label>{{ $t('Group by') }}</label>
              <Select
                v-model="dashcomponent.group_by"
                :options="builder.groups" />
              <ValidateMessage :error="validateErrors.group_by" />
            </div>
            <div
              v-if="isGroupDate"
              class="form-group">
              <label>{{ $t('Group range') }}</label>
              <select
                class="form-control"
                v-model="dashcomponent.group_range">
                <option value="day">Dia</option>
                <option value="month">Mês</option>
                <option value="year">Ano</option>
              </select>
              <ValidateMessage :error="validateErrors.group_range" />
            </div>
          </div>
          <div
            v-if="['columns', 'pizza'].includes(dashcomponent.type)"
            class="form-group">
            <label>{{ $t('Segment by') }}</label>
            <Select
              v-model="dashcomponent.segment_by"
              :options="builder.segments" />
            <ValidateMessage :error="validateErrors.segment_by" />
          </div>
          <div
            class="form-group"
            v-if="['columns', 'pizza', 'summary'].includes(dashcomponent.type)">
            <label>{{ $t('Metric') }}</label>
            <Select
              v-model="dashcomponent.metric"
              :options="builder.metrics" />
            <ValidateMessage :error="validateErrors.metric" />
          </div>
          <div
            class="form-group"
            v-if="['table'].includes(dashcomponent.type)">
            <label>{{ $t('Columns') }}</label>
            <SelectColumns
              v-model="dashcomponent.select"
              :options="builder.select"
              multiple />
            <ValidateMessage :error="validateErrors.select" />
          </div>
        </div>
        <div class="col-md-9">
          <div class="mb-3">
            <h6>{{ $t('Filters') }}</h6>
            <DashcomponentFilters
              v-model="dashcomponent.filters"
              :filters="builder.filters"
              :validateErrors="validateErrors" />
          </div>
 
          <div class="card p-4">
            <div class="bg-white">
              <ReportChart
                :disableGlobalFilters="true"
                :dashcomponent="dashcomponent"
                :loading="false" />
            </div>
          </div>
        </div>
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="button"
          style="float: right"
          class="btn btn-link"
          @click="showModules()">{{ $t('Change module') }}</button>
        <button
          type="submit"
          form="dashcomponent-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import DashcomponentFilters from './DashcomponentFilters'
import DashcomponentFormModules from './DashcomponentFormModules'
import ReportChart from './ReportChart/index'
import Select from '@/components/Fields/Select'
import SelectColumns from '@/components/Fields/SelectColumns'

export default {
  name: 'DashcomponentForm',
  components: {
    DashcomponentFilters,
    DashcomponentFormModules,
    ReportChart,
    Select,
    SelectColumns
  },
  props: [
    'initDashcomponent'
  ],
  computed: {
    isGroupDate () {
      const groupIfo = this.builder.groups.find(v => v.value === this.dashcomponent.group_by)
      return groupIfo ? groupIfo.type === 'date' : false
    }
  },
  data () {
    return {
      loading: false,
      dashcomponent: this.defaultValues(this.initDashcomponent),
      validateErrors: {},
      stage: null,
      builder: null,
      creating: true
    }
  },
  created () {
    if (this.dashcomponent._id) {
      this.showBuilder(this.dashcomponent.module)
    } else {
      this.creating = false
      this.showModules()
    }
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        type: 'columns',
        group_range: 'month',
        select: []
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveDashcomponent
    */
    saveDashcomponent (data) {
      if (data._id) this.updateDashcomponent(data)
      else this.createDashcomponent(data)
    },
    /*
    createDashcomponent
    */
    createDashcomponent (data) {
      this.loading = true

      this.$store
      .dispatch('createDashcomponent', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateDashcomponent
    */
    updateDashcomponent (data) {
      this.loading = true

      this.$store
      .dispatch('updateDashcomponent', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    selectModule
    */
    selectModule (_module) {
      this.dashcomponent.module = _module
      this.showBuilder(_module)
    },
    /*
    showBuilder
    */
    showBuilder (_module) {
      return this.axios.get('/accounts/' + this.$store.getters.getAccount._id + '/reporting/builder/modules/' + _module).then(result => {
        this.builder = result.data
        this.stage = 'builder'
        this.creating = false
      })
    },
    /*
    showModules
    */
    showModules () {
      this.stage = 'modules'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DashcomponentForm.vue